import { LightType } from '@inter-ikea-betrakta/viewer';
import LightSource from './LightSource';
export class LineLightSource extends LightSource {
    constructor(viewer, parentId, intensity, color, width, visible, angle) {
        super(viewer, color);
        this.sourceModelId = viewer.create_box(width - 0.01, 0.006, 0.019, this.viewer.create_material());
        const localDepthDirection = -0.012;
        this.setSourceModelId(this.sourceModelId);
        viewer.set_parent(this.sourceModelId, parentId);
        viewer.set_position(this.sourceModelId, 0, 0, localDepthDirection);
        viewer.set_rotation(this.sourceModelId, Math.PI / 2, 0, 0);
        viewer.set_visible(this.sourceModelId, visible);
        this.light = viewer.create_light(LightType.LINE_LIGHT);
        this.light.intensity = intensity;
        this.light.parent = this.sourceModelId; // Setting the box as the parent of the light. This makes the light follow the box. Also makes it possible to position the light close to the box
        this.light.position.set(-0.01, 0.01, localDepthDirection + 0.01); // Move the light a bit to the side and up to make it shine on the frame
        this.light.intensity_affects_parent_emission_color = true; // This makes the light affect the color of the box. Create the shine effect
        this.light.color.set(color.r, color.g, color.b);
        this.light.width = width + 0.02; // Add some width to the light to make it cover the whole width of the box and shine a bit on the frame sides
        this.light.angle_direction_degrees = -(angle / 2) + 10; // Add a bit of upwards angle to the light to make it shine up in the frame top corner
        this.light.angle_range_degrees = angle; // Set the spread angle of the light
        this.light.rotation_radians = Math.PI / 2; // Rotate the light to be horizontal
        this.light.hard_side_cutoff = true; // If line light should spread to the sides or not
    }
}
//# sourceMappingURL=LineLightSource.js.map